import { numericBreaks } from 'syf-component-library/const/mediaQueries';
/**
 * The rewards-mfe package exposes only the RewardsPage and RewardsModal components. To ensure these components fit well within
 * the screen sizes and layouts of host applications, we define custom pixel breakpoints for desktop and tablet views.
 *
 * These custom breakpoints (desktop: 1344px, tablet: 876px) are calculated by adjusting the base breakpoints
 * from the syf-component-library (desktop: huge = 1440px, tablet: medium = 768px) to better match the design
 * and layout requirements of the host environments. Specifically:
 *   - Desktop: 1344px = 1440px (huge) - 96px
 *   - Tablet: 876px = 768px (medium) + 108px
 *
 * This allows us to control when the UI switches between desktop and mobile/tablet views for the MFE, while
 * using the standard media queries from syf-component-library (exported as 'query') for all other cases.
 */
export var customNumericBreaks = {
    desktop: numericBreaks.huge - 96,
    tablet: numericBreaks.medium + 108
};
var customBreakPoints = {
    desktopBreakpoint: "(max-width: ".concat(customNumericBreaks.desktop - 1, "px)"),
    tabletBreakpoint: "(max-width: ".concat(customNumericBreaks.tablet - 1, "px)"),
    minWidthTabletBreakpoint: "(min-width: ".concat(customNumericBreaks.tablet, "px)"),
    minWidthDesktopBreakpoint: "(min-width: ".concat(customNumericBreaks.desktop, "px)")
};
export default customBreakPoints;
export { default as query } from 'syf-component-library/const/mediaQueries';
